import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ErrorPage6 } from "./ErrorPage6";

export default function ErrorsPage() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/error/error-v6" replace />} />
      <Route path="/error-v6" element={<ErrorPage6 />} />
    </Routes>
  );
}
